import Vue from "vue";
import DatePicker from "vue2-datepicker";
import SortedTablePlugin from "vue-sorted-table";
import Paginate from "@/components/widgets/pagination.vue";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { TH_SARABUN_TTF_BASE64 } from "@/assets/fonts/thsarabun.js";

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>',
});

export default {
  components: {
    DatePicker,
    Paginate,
  },
  data: function () {
    return {
      busy: false,
      date_start: null,
      date_end: null,
      perPage: 6,
      sortBy: "name",
      currentPage: 1,
      currentData: {},
      sortDesc: false,
      totalItem: 0,
      apiStatus: "กรุณาระบุวันที่และกดปุ่มแสดงข้อมูลเพื่อค้นหาข้อมูล",
      fields: [
        {
          key: "index",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "document_no",
          label: "เลขที่เอกสาร",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "created_at",
          label: "วันที่",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "created_at2",
          label: "วันครบกำหนด",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "created_at",
          label: "วันครบกำหนดชำระ",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "bill_customer_name",
          label: "รายละเอียดลูกค้า",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "total_price",
          label: "ยอดขาย ฿",
          sortable: true,
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "font-weight-bold text-black td-top text-xs-1/2",
          class: "text-right",
        },
      ],
      sellerFields: [
        {
          key: "index",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-xs-1/2 td-top",
        },
        {
          key: "sale_id",
          label: "รหัสพนักงานขาย",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-xs-1/2 td-top",
        },
        {
          key: "name",
          label: "ชื่อพนักงานขาย",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-xs-1/2 td-top",
        },
        {
          key: "total_price",
          label: "ยอดขายรวม",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "font-weight-bold text-xs-1/2 td-top",
          sortable: true,
        },
        {
          key: "documents",
          label: "รายการบิลขาย",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-xs-1/2 td-top",
        },
      ],

      // Inner table columns (per‐document)
      docFields: [
        {
          key: "index",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-xs-1/2 td-top",
        },
        {
          key: "id",
          label: "เลขที่เอกสาร",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-xs-1/2",
        },
        {
          key: "created_at",
          label: "วันที่สร้าง",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-xs-1/2",
        },
        {
          key: "bill_duedate",
          label: "วันครบกำหนด",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-xs-1/2",
        },
        {
          key: "customer_code",
          label: "รหัสลูกค้า",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-xs-1/2",
        },
        {
          key: "customer",
          label: "ชื่อลูกค้า",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-xs-1/2",
        },
        // { key: 'bill_before_vat', label: 'ยอดก่อน VAT', thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2'  },
        // { key: 'bill_value_added_tax', label: 'VAT', thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2'  },
        {
          key: "total_price",
          label: "ยอดรวม",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-xs-1/2",
        },
      ],
      items: [],
      form: {
        sale_id: null,
        start_date: new Date(moment().startOf("month").format("YYYY-MM-DD")),
        end_date: new Date(moment().endOf("month").format("YYYY-MM-DD")),
      },
      seller_list: [],
      sum: 0,
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  methods: {
    async onInitData() {
      try {
        const item = this.items;
        this.items = [];
        this.busy = true;
        this.apiStatus = "กำลังค้นหาข้อมูล..";

        const res = await this.$axios.get(
          this.$host +
            "/api/v1/report/employeebydate?sale_id=" +
            (this.form.sale_id ? this.form.sale_id : "") +
            "&keyword_startdate=" +
            moment(this.form.start_date).format("YYYY-MM-DD") +
            "&keyword_enddate=" +
            moment(this.form.end_date).format("YYYY-MM-DD")
        );

        const data = res.data;

        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";
        this.items = data.data;
        this.sum = data.sum;
      } catch (error) {
        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    async onLoadEmployee() {
      try {
        this.loading = true;
        const res = await this.$axios.get(
          this.$host + "/api/v1/document/quotation/branch/employee"
        );

        const newObj = { name: "--- ทั้งหมด ---", id: null };
        this.seller_list = res.data;

        this.seller_list.unshift(newObj);

        this.loading = false;
      } catch (error) {
        this.loading = false;

        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },

    addThaiFont(doc) {
      if (!doc) return;
      // ลงทะเบียนฟอนต์
      doc.addFileToVFS("THSarabun.ttf", TH_SARABUN_TTF_BASE64);
      doc.addFont("THSarabun.ttf", "THSarabun", "normal");
      doc.addFont("THSarabun.ttf", "THSarabun", "bold");
    },
    async exportPDFReport() {
      if (!this.items || this.items.length === 0) {
        this.$bvToast.toast("ไม่มีข้อมูลให้ส่งออก", {
          title: "Export PDF",
          variant: "warning",
          solid: true,
        });
        return;
      }
    
      // 1) เตรียมเอกสาร A4 landscape
      const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
      this.addThaiFont(doc);
      doc.setFont("THSarabun", "normal");
      doc.setFontSize(14);
    
      // margins + ขนาดหน้า
      const margin = { top: 80, right: 36, bottom: 48, left: 36 };
      const pageW = doc.internal.pageSize.getWidth();
      const pageH = doc.internal.pageSize.getHeight();
    
      // Header/ Footer
      const reportTitle = "รายงานวิเคราะห์ขาย สรุปยอดขายตาม พนักงาน+วันที่";
      const periodText = `ช่วงวันที่: ${moment(this.form.start_date).format("DD/MM/YYYY")} - ${moment(this.form.end_date).format("DD/MM/YYYY")}`;
    
      const drawHeader = () => {
        doc.setFont("THSarabun", "bold");
        doc.setFontSize(18);
        doc.text(reportTitle, margin.left, 40);
        doc.setFont("THSarabun", "normal");
        doc.setFontSize(14);
        doc.text(periodText, margin.left, 60);
      };
    
      const drawFooter = (pageNumber) => {
        doc.setFont("THSarabun", "normal");
        doc.setFontSize(12);
        doc.text(`หน้า ${pageNumber}`, pageW - margin.right, pageH - 20, { align: "right" });
      };
    
      let pageNumber = 1;
      drawHeader();
      drawFooter(pageNumber);
    
      // 2) ส่วนหัวตาราง
      const tableHead = [[
        "#",
        "รหัสเอกสาร",
        "วันที่เอกสาร",
        "วันที่ครบกำหนด",
        "รหัสลูกค้า",
        "ชื่อลูกค้า",
        "บริษัท",
        "ยอดรวม (บาท)",
      ]];
    
      // helpers
      const fmtDate = (d) => {
        if (!d) return "-";
        const m = moment(d);
        return m.isValid() ? m.format("DD/MM/YYYY") : "-";
      };
      const fmtMoney = (n) => this.formatCurrency(n || 0);
    
      // column widths (รวมแล้วพอดี A4 ลบ margin)
      const columnStyles = {
        0: { cellWidth: 24, halign: "right" }, // #
        1: { cellWidth: 95 },                  // รหัสเอกสาร
        2: { cellWidth: 70 },                  // วันที่เอกสาร
        3: { cellWidth: 80 },                  // วันที่ครบกำหนด
        4: { cellWidth: 70 },                  // รหัสลูกค้า
        5: { cellWidth: 130 },                 // ชื่อลูกค้า
        6: { cellWidth: 130 },                 // บริษัท
        7: { cellWidth: 80, halign: "right" }, // ยอดรวม (บาท)
      };
    
      const rowStyleSellerHeader = { fillColor: [220, 230, 241] };
      const rowStyleMuted = { fillColor: [245, 245, 245] };
      const rowStyleSubtotal = { fillColor: [230, 240, 255] };
      const rowStyleGrand = { fillColor: [211, 223, 211] };
    
      let globalIndex = 0;
      let grandTotal = 0;
    
      // 3) วาดกลุ่มตามพนักงานขาย
      this.items.forEach((seller) => {
        const docs = Array.isArray(seller.documents) ? seller.documents : [];
        let subTotal = 0;
    
        // พาดหัวกลุ่มพนักงาน (bar เต็มกว้าง)
        const yBase = (doc.lastAutoTable ? doc.lastAutoTable.finalY : margin.top) + 30;
    
        // ขึ้นหน้าใหม่ถ้าที่ไม่พอ
        if (yBase > pageH - margin.bottom - 60) {
          doc.addPage();
          pageNumber += 1;
          drawHeader();
          drawFooter(pageNumber);
        }
    
        const sellerTitle = `พนักงานขาย: ${seller.name || "-"} (รหัส: ${seller.sale_id ?? "-"})    ยอดขายรวม: ${fmtMoney(seller.total_price || 0)} บาท`;
        doc.setFont("THSarabun", "bold");
        doc.setFontSize(14);
        doc.setFillColor(...rowStyleSellerHeader.fillColor);
        doc.rect(margin.left, yBase - 18, pageW - margin.left - margin.right, 24, "F");
        doc.text(sellerTitle, margin.left + 8, yBase);
    
        // เตรียม rows
        const bodyRows = [];
        if (docs.length === 0) {
          bodyRows.push(["", "— ไม่มีรายการบิลขาย —", "", "", "", "", "", fmtMoney(0)]);
        } else {
          docs.forEach((d) => {
            globalIndex += 1;
            subTotal += parseFloat(d.total_price || 0);
            grandTotal += parseFloat(d.total_price || 0);
            bodyRows.push([
              globalIndex,
              d.id ?? "-",
              fmtDate(d.created_at),
              fmtDate(d.bill_duedate),
              d.customer_code ?? "-",
              d.customer?.name || "-",
              d.customer?.company_name || "-",
              fmtMoney(d.total_price || 0),
            ]);
          });
        }
    
        // ตารางรายละเอียดของกลุ่ม (หัวตาราง 1 ครั้ง/กลุ่ม)
        doc.autoTable({
          startY: yBase + 12,
          head: tableHead,
          body: bodyRows,
          margin,
          pageBreak: "auto",
          tableWidth: "wrap",
          styles: {
            font: "THSarabun",
            fontSize: 10,           // เล็กลงให้พอดี A4
            cellPadding: 3,         // ลด padding
            overflow: "linebreak",  // ตัดบรรทัดอัตโนมัติ
            lineColor: [220, 220, 220],
            lineWidth: 0.2,
          },
          headStyles: { fillColor: [240, 240, 240], textColor: 20, halign: "center" },
          columnStyles,
          didDrawPage: (data) => {
            if (data.pageNumber > pageNumber) {
              pageNumber = data.pageNumber;
              drawHeader();
              drawFooter(pageNumber);
            }
          },
          willDrawCell: (data) => {
            if (data.section === "body" && data.row.raw && data.row.raw[1] === "— ไม่มีรายการบิลขาย —") {
              Object.assign(data.cell.styles, rowStyleMuted);
            }
          },
        });
    
          // แทรก Subtotal ต่อพนักงาน (แถวเดียว theme plain)
          doc.autoTable({
            startY: doc.lastAutoTable.finalY + 2,
            body: [[ "", "", "", "", "", "", "ยอดขายรวมพนักงาน", fmtMoney(subTotal) ]],
            theme: "plain",
            margin,
            styles: { font: "THSarabun", fontSize: 11, cellPadding: 4 },
            columnStyles: {
              0: { cellWidth: 24 }, 1: { cellWidth: 95 }, 2: { cellWidth: 70 },
              3: { cellWidth: 80 }, 4: { cellWidth: 70 }, 5: { cellWidth: 130 },
              6: { cellWidth: 130 }, 7: { cellWidth: 80, halign: "right" },
            },
            didParseCell: (data) => Object.assign(data.cell.styles, rowStyleSubtotal),
          });
    
          // เว้นระยะท้ายกลุ่ม
          doc.autoTable({
            startY: doc.lastAutoTable.finalY + 4,
            body: [[" "]],
            theme: "plain",
            margin,
            styles: { font: "THSarabun", fontSize: 8, cellPadding: 2 },
          });
      });
    
      // 4) Grand Total ท้ายเอกสาร
      doc.autoTable({
        startY: (doc.lastAutoTable ? doc.lastAutoTable.finalY : margin.top) + 6,
        body: [[ "", "", "", "", "", "", "ยอดรวมทั้งหมด", fmtMoney(grandTotal) ]],
        theme: "plain",
        margin,
        styles: { font: "THSarabun", fontSize: 12, cellPadding: 6 },
        columnStyles: {
          0: { cellWidth: 24 }, 1: { cellWidth: 95 }, 2: { cellWidth: 70 },
          3: { cellWidth: 80 }, 4: { cellWidth: 70 }, 5: { cellWidth: 130 },
          6: { cellWidth: 130 }, 7: { cellWidth: 80, halign: "right" },
        },
        didParseCell: (data) => Object.assign(data.cell.styles, rowStyleGrand),
      });
    
      // 5) บันทึกไฟล์
      const fileName = `รายงานยอดขาย_${new Date().toLocaleDateString("th-TH")}.pdf`;
      doc.save(fileName);
    },

    // ── helpers สำหรับ Excel ─────────────────────────────────────────────────────
    toExcelDate(d) {
      // รับทั้ง Date จริง ๆ หรือ string Y-M-D/ISO แล้วคืนค่า Date สำหรับ Excel
      if (!d) return null;
      const m = moment(d);
      return m.isValid() ? m.toDate() : null;
    },

    exportExcelReport() {
      if (!this.items || this.items.length === 0) {
        this.$bvToast.toast("ไม่มีข้อมูลให้ส่งออก", {
          title: "Export Excel",
          variant: "warning",
          solid: true,
        });
        return;
      }

      // helper แปลงวันที่ให้เป็น Date object (รองรับ ISO มี Z)
      const toExcelDate = (d) => {
        if (!d) return null;
        const m = moment(d);
        return m.isValid() ? m.toDate() : null;
      };

      const aoa = [];
      const title = "รายงานวิเคราะห์ขาย สรุปยอดขายตาม พนักงาน+วันที่";
      const period = `ช่วงวันที่: ${moment(this.form.start_date).format(
        "DD/MM/YYYY"
      )} - ${moment(this.form.end_date).format("DD/MM/YYYY")}`;
      aoa.push([title]);
      aoa.push([period]);
      aoa.push([]);

      const header = [
        "#",
        "รหัสเอกสาร",
        "วันที่เอกสาร",
        "วันที่ครบกำหนด",
        "รหัสลูกค้า",
        "ชื่อลูกค้า",
        "บริษัท",
        "ยอดรวม (บาท)",
      ];
      const headerRowIdx = aoa.length;
      aoa.push(header);

      const merges = [];
      const numberFormats = {};
      let runningIndex = 0;
      let grandTotal = 0;

      // items = [{ sale_id, name, total_price, documents: [...] }]
      this.items.forEach((seller) => {
        const docs = Array.isArray(seller.documents) ? seller.documents : [];

        // แถบหัวกลุ่มพนักงาน
        const sellerTitle = `พนักงานขาย: ${seller.name || "-"} (รหัส: ${
          seller.sale_id ?? "-"
        })  ยอดขายรวม: ${this.formatCurrency(seller.total_price || 0)} บาท`;
        aoa.push([sellerTitle]);
        const sellerTitleRowIdx = aoa.length - 1;
        merges.push({
          s: { r: sellerTitleRowIdx - 1, c: 0 },
          e: { r: sellerTitleRowIdx - 1, c: header.length - 1 },
        });

        let sellerSubtotal = 0;

        if (docs.length === 0) {
          // ไม่มีรายการบิลขาย -> ใส่บรรทัดแจ้งเตือน + subtotal = 0
          aoa.push(["", "— ไม่มีรายการบิลขาย —", "", "", "", "", "", 0]);
          numberFormats[`H${aoa.length}`] = "#,##0.00";
        } else {
          docs.forEach((doc) => {
            runningIndex += 1;
            const row = [
              runningIndex,
              // ใช้ id เป็น "เลขที่เอกสาร" ตามตัวอย่าง response
              doc.id ?? "-",
              toExcelDate(doc.created_at), // "2025-10-08T17:49:26.000000Z"
              toExcelDate(doc.bill_duedate), // "2025-10-08"
              doc.customer_code ?? "-",
              doc.customer?.name || "-",
              doc.customer?.company_name || "-",
              +parseFloat(doc.total_price || 0),
            ];
            aoa.push(row);

            const r = aoa.length;
            numberFormats[`C${r}`] = "dd/mm/yyyy";
            numberFormats[`D${r}`] = "dd/mm/yyyy";
            numberFormats[`H${r}`] = "#,##0.00";

            sellerSubtotal += parseFloat(doc.total_price || 0);
            grandTotal += parseFloat(doc.total_price || 0);
          });
        }

        // subtotal ต่อพนักงาน
        aoa.push(["", "", "", "", "", "", "ยอดขายรวมพนักงาน", sellerSubtotal]);
        numberFormats[`H${aoa.length}`] = "#,##0.00";

        // คั่นกลุ่ม
        aoa.push([]);
      });

      // Grand Total
      aoa.push(["", "", "", "", "", "", "ยอดรวมทั้งหมด", grandTotal]);
      numberFormats[`H${aoa.length}`] = "#,##0.00";

      // สร้าง sheet
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      if (merges.length) ws["!merges"] = merges;

      // ความกว้างคอลัมน์
      ws["!cols"] = [
        { wch: 5 }, // #
        { wch: 20 }, // รหัสเอกสาร
        { wch: 16 }, // วันที่เอกสาร
        { wch: 16 }, // วันที่ครบกำหนด
        { wch: 14 }, // รหัสลูกค้า
        { wch: 28 }, // ชื่อลูกค้า
        { wch: 28 }, // บริษัท
        { wch: 16 }, // ยอดรวม (บาท)
      ];

      // AutoFilter เฉพาะบรรทัด header หลัก
      const cellRef = (r, c) => XLSX.utils.encode_cell({ r, c });
      ws["!autofilter"] = {
        ref: `${cellRef(headerRowIdx, 0)}:${cellRef(
          headerRowIdx,
          header.length - 1
        )}`,
      };

      // ใส่รูปแบบตัวเลข/วันที่
      Object.keys(numberFormats).forEach((addr) => {
        if (!ws[addr]) return;
        ws[addr].t = ws[addr].t || (addr.startsWith("H") ? "n" : "d");
        ws[addr].z = numberFormats[addr];
      });

      // สร้าง workbook และบันทึก
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "รายงานยอดขาย");
      const fileName = `รายงานยอดขาย_${new Date().toLocaleDateString(
        "th-TH"
      )}.xlsx`;
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName);
    },

    // helper functions (you already have these)
    formatCurrency(value) {
      return parseFloat(value || 0).toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatShortDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    parseYMD(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
  async mounted() {
    await this.onLoadEmployee();
  },
};
